import {makeStyles} from "tss-react/mui";

export const useIntegrationStyles = makeStyles()((theme) => ({
  card: {
    width: 200,
    height: 80,
    position: "relative",
    backgroundColor: theme.palette.draggable.accent,
    border: `1.5px solid ${theme.palette.grey[theme.palette.mode === "dark" ? "800" : "400"]}`,
    "&:hover": {
      cursor: "pointer",
      border: `1.5px solid ${theme.palette.primary.main}`,
    },
    "@media print": {
      height: "75px",
    },
  },
  attribute: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  attributeNoBorder: {
    paddingBottom: 0,
    paddingTop: 0,
    border: 0,
  },
  logo: {
    maxWidth: 125,
    maxHeight: 80,
  },
  logoDetail: {
    height: 100,
    width: 100,
    marginRight: "1.5em",
  },
  magnitudeLogoDetail: {
    objectFit: "contain",
  },
  torqHeader: {
    gap: theme.spacing(3),
    "& > :first-child": {
      flex: 1,
      minWidth: 0,
    },
  },
  torqLogoDetail: {
    flex: "0 0 120px",
    width: 120,
    height: 100,
    objectFit: "contain",
  },
  noPrint: {
    "@media print": {
      display: "none",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-around",
  },
  link: {
    marginLeft: ".5em",
    textDecoration: "underline",
  },
  isEnabledIcon: {
    position: "absolute",
    top: ".25em",
    right: ".25em",
    color: theme.palette.primary.main,
  },
  connectionInstructions: {
    marginTop: "1em",
  },
  copyGridWrapper: {
    display: "grid",
    gridTemplateColumns: "min-content min-content",
    gap: theme.spacing(1),
    alignItems: "baseline",
    justifyItems: "start",
  },
  noWrap: {
    whiteSpace: "nowrap",
  },
  preview: {
    color: theme.palette.primary.main,
    textTransform: "uppercase",
    fontSize: "1.2rem",
    fontWeight: 600,
  },
  orderedSteps: {
    listStyle: "decimal outside",
    paddingInlineStart: "1.5rem",
    "& > li": {
      listStyle: "decimal outside",
      display: "list-item",
    },
  },
  unorderedSteps: {
    listStyle: "disc outside",
    paddingInlineStart: "1.5rem",
    "& > li": {
      listStyle: "disc outside",
      display: "list-item",
    },
  },
}));
